import { ChartDto, ChartSeriesDto, ChartPointDto } from "../models/chart.model";
import { TimeSeriesResponseDto } from "../models/time-series-response.model";

type Aggregation = TimeSeriesResponseDto['aggregation'];

function getXAxisLabel(agg: Aggregation): string {
  switch (agg) {
    case 'Day': return 'Tag';
    case 'Week': return 'Woche';
    case 'Month': return 'Monat';
    case 'Quarter': return 'Quartal';
    case 'Year': return 'Jahr';
    default: return 'Datum';
  }
}

function getXAxisFormat(agg: Aggregation): string {
  switch (agg) {
    case 'Day': return 'dd.MM';
    case 'Week': return "'KW' ww";
    case 'Month': return 'MM.yy';
    case 'Quarter': return "'Q'Q yy";
    case 'Year': return 'yyyy';
    default: return 'yyyy-MM-dd';
  }
}

// Mapper-Funktion, um TimeSeriesResponseDto in ChartDto zu transformieren
export function timeSeriesToChart(
  ts: TimeSeriesResponseDto,
  options?: {
    chartType?: ChartDto['chartType']; // default 'combo'
    useCategoryAxis?: boolean;         // default false
    seriesTypeByKey?: Record<string, ChartSeriesDto['type']>; // z.B. { actual:'bar', target:'line' }
  }
): ChartDto {
  const chartType = options?.chartType ?? 'combo';

  const useCategoryAxis = options?.useCategoryAxis ?? false;
  const seriesTypeByKey = options?.seriesTypeByKey ?? { actual: 'bar', target: 'line' };

  const series: ChartSeriesDto[] = ts.series.map(s => ({
    key: s.key,
    label: s.label,
    unit: s.unit ?? undefined,
    type: seriesTypeByKey[s.key] ?? (chartType === 'combo' ? 'line' : undefined),
  }));

  const points: ChartPointDto[] = ts.items.map(i => ({
    x: useCategoryAxis ? i.key : i.periodStart, 
    labels: (i.labels ?? {}) as Record<string, string | null>,
    values: i.values, 
  }));

  return {
    title: ts.title,
    chartType,
    xAxis: {
      key: 'date',
      label: getXAxisLabel(ts.aggregation),
      type: useCategoryAxis ? 'category' : 'date',
      format: useCategoryAxis ? undefined : getXAxisFormat(ts.aggregation),
    },
    series,
    points,
    meta: {
      ...ts.meta,
      aggregation: ts.aggregation,
      dateFrom: ts.dateFrom,
      dateTo: ts.dateTo,
      totals: ts.totals,
    },
  };
}
